export const UPDATE_VERIFICATE_QUERY_DATA = 'verificateQuery/UPDATE_VERIFICATE_QUERY_DATA';
const initialState = {
    verificateQueryData:{
        auditId:'',
        searchResult:{},
        didQuery:false,
    },
};
const verificateQueryDataReducer =  (verificateQueryData=0, action)=>{
    switch (action.type) {
        case UPDATE_VERIFICATE_QUERY_DATA:
            return {
                ...verificateQueryData,
                [action.subType]:action.data
            }
        default:
            return verificateQueryData
    }
}
export default (state = initialState, action) => {
    return {
        verificateQueryData : verificateQueryDataReducer(state.verificateQueryData, action)
    };
}
export const dispatch_func = {
    update_verificateQueryData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_VERIFICATE_QUERY_DATA,
                data:data,
                subType:type
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/modules/verificateQuery.js